import { SVGProps } from 'react';

const ChartNoAxesColumnIncreasing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 20V10m6 10V4M6 20v-4"
    />
  </svg>
);
export default ChartNoAxesColumnIncreasing;
